import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  CarrierPayments,
  ShipperPaymentCreate,
  ShipperPayments,
  SuperAdminPayments,
} from '../../models/payment';
import { BankDetailCreate, BankDetailRead } from '../../models/bank';
import { UserTypeEnum } from '../../enums/auth';
import { SuperAdminCarrierPaymentStausEnum } from '../../enums/payment';
import { CarrierRating, ShipperRating } from '../../models/rate';

export const paymentEvents = eventGroup({
  source: 'Payment',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),

    loadCarrierBankInfo: type<string>(),
    loadedCarrierBankInfo: type<BankDetailRead[]>(),
    clearCarrierBankInfo: type<void>(),

    loadCarrierPayments: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedCarrierPayments: type<CarrierPayments[]>(),

    loadShipperPayments: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedShipperPayments: type<ShipperPayments[]>(),

    loadSuperAdminPayments: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedSuperAdminPayments: type<SuperAdminPayments[]>(),

    loadBankDetails: type<string>(),
    loadedBankDetails: type<BankDetailRead[]>(),

    confirmCarrierPayment: type<{
      acPaymentId: number;
      confirmPrepayment: boolean;
      confirmPostpayment: boolean;
    }>(),

    updateSuperAdminCarrierPayment: type<{
      sub: string;
      jobId: number;
      carrier_payment: SuperAdminCarrierPaymentStausEnum;
    }>(),

    createSuperAdminPayment: type<{
      loadId: number;
      loadNo: string;
      jobNo: string;
      amount: number;
      paymentDirection: string;
    }>(),

    createShipperPayment: type<ShipperPaymentCreate>(),

    createBankDetail: type<{
      sub: string;
      userType: UserTypeEnum;
      payload: BankDetailCreate;
    }>(),

    updateBankDetail: type<{
      sub: string;
      existingAccountNumber: string;
      payload: Partial<BankDetailRead>;
    }>(),

    deleteBankDetail: type<{
      sub: string;
      accountNumber: string;
    }>(),

    rateCarrier: type<CarrierRating>(),
    rateShipper: type<ShipperRating>(),
  },
});
